// iSight Customer Management Action Types

// Tenant related actions
export const FETCH_TENANTS_INIT = "FETCH_TENANTS_INIT";
export const FETCH_TENANTS_SUCCESS = "FETCH_TENANTS_SUCCESS";
export const FETCH_TENANTS_ERROR = "FETCH_TENANTS_ERROR";

// Customer CRUD actions
export const FETCH_CUSTOMERS_INIT = "FETCH_CUSTOMERS_INIT";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_ERROR = "FETCH_CUSTOMERS_ERROR";

export const CREATE_CUSTOMER_INIT = "CREATE_CUSTOMER_INIT";
export const CREATE_CUSTOMER_SUCCESS = "CREATE_CUSTOMER_SUCCESS";
export const CREATE_CUSTOMER_ERROR = "CREATE_CUSTOMER_ERROR";

export const UPDATE_CUSTOMER_INIT = "UPDATE_CUSTOMER_INIT";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_ERROR = "UPDATE_CUSTOMER_ERROR";

export const DELETE_CUSTOMER_INIT = "DELETE_CUSTOMER_INIT";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_ERROR = "DELETE_CUSTOMER_ERROR";

// Form state actions
export const SET_FORM_DATA = "SET_FORM_DATA";
export const RESET_FORM_DATA = "RESET_FORM_DATA";
export const SET_EDITING_CUSTOMER = "SET_EDITING_CUSTOMER";
export const CLEAR_EDITING_CUSTOMER = "CLEAR_EDITING_CUSTOMER";

// UI state actions
export const SET_SELECTED_TENANT = "SET_SELECTED_TENANT";
export const SET_LOADING_STATE = "SET_LOADING_STATE";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";
export const SET_SUCCESS_MESSAGE = "SET_SUCCESS_MESSAGE";
export const CLEAR_SUCCESS_MESSAGE = "CLEAR_SUCCESS_MESSAGE";

// Modal actions
export const SHOW_DELETE_MODAL = "SHOW_DELETE_MODAL";
export const HIDE_DELETE_MODAL = "HIDE_DELETE_MODAL";

// Agent management actions
export const SET_SELECTED_CUSTOMER = "SET_SELECTED_CUSTOMER";
export const FETCH_AGENTS_INIT = "FETCH_AGENTS_INIT";
export const FETCH_AGENTS_SUCCESS = "FETCH_AGENTS_SUCCESS";
export const FETCH_AGENTS_ERROR = "FETCH_AGENTS_ERROR";
